/**
 * @generated SignedSource<<0c0420673fe94f17f1238fa894bc1cf6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStatus = "AVAILABLE" | "IN_USE" | "LOST" | "MAINTENANCE" | "RETIRED" | "%future added value";
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type OpsInventoryPageQuery$variables = {
  category?: EquipmentCategory | null | undefined;
  search?: string | null | undefined;
};
export type OpsInventoryPageQuery$data = {
  readonly assets: {
    readonly nodes: ReadonlyArray<{
      readonly assetTag: any;
      readonly category: EquipmentCategory;
      readonly id: string;
      readonly kit: {
        readonly assetTag: any;
        readonly id: string;
      } | null | undefined;
      readonly kitMembers: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly name: string;
      readonly rentable: boolean;
      readonly serial: string | null | undefined;
      readonly status: AssetStatus;
    } | null | undefined> | null | undefined;
  };
};
export type OpsInventoryPageQuery = {
  response: OpsInventoryPageQuery$data;
  variables: OpsInventoryPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "category"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTag",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "category",
        "variableName": "category"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "AssetConnection",
    "kind": "LinkedField",
    "name": "assets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rentable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serial",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kit",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "kitMembers",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsInventoryPageQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OpsInventoryPageQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "039d39ee4a0bb17a764f6c450fafe9f6",
    "id": null,
    "metadata": {},
    "name": "OpsInventoryPageQuery",
    "operationKind": "query",
    "text": "query OpsInventoryPageQuery(\n  $search: String\n  $category: EquipmentCategory\n) {\n  assets(search: $search, category: $category, first: 200) {\n    nodes {\n      id\n      assetTag\n      name\n      category\n      status\n      rentable\n      serial\n      kit {\n        id\n        assetTag\n      }\n      kitMembers {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "df2196816c3ce983bcd276e85864d21b";

export default node;
